'use strict';

angular.module('theme').config(function ($translateProvider) {
	$translateProvider.translations('nb', {
		'ORDER': {
			'BREADCRUMB': {
				'CART': 'Handlekurv',
				'DETAILS': 'Informasjon',
				'START_WEEK': 'Startuke',
				'PAY': 'Betale'
			},
			'CART': {
				'TITLE': 'Handlekurv',
				'TOTAL': 'Totalt å betale',
				'TESTWEEK': 'Jeg ønsker bare å teste Matkomfort i en uke, uten at det kommer flere leveranser automatisk.',
				'SUPPLEMENTS': {
					'INFO': 'Hva er ekstra hovedråvare?',
					'TEXT': 'Du kan velge å utvide med ekstra av hovedråvaren. Dette innebærer at du får to porsjoner av fugl, fisk og/eller kjøtt.'
				},
				'SHOW_CODES': 'Har du et gavekort eller kampanjekode , klikke her.',
				'GIFTCARD': {
					'TITLE': 'Gavekort',
					'INPUT': 'Skriv inn gavekortkoden'
				},
				'DISCOUNT': {
					'TITLE': 'Kampanjekode',
					'INPUT': 'Skriv inn kampanjekode',
					'SELECTION': 'Bekreft'
				},
				'ACTIVATE': 'Aktiver',
				'NEXT': 'Gå videre'
			},
			'LOGIN': {
				'EXISTING': {
					'TITLE': 'Eksisterende kunde',
					'FACEBOOK': 'Logg inn med Facebook',
					'ERROR': 'Det gikk ikke å logge deg på.',
					'BUTTON': 'Logg på'
				},
				'CREATE': {
					'TITLE': 'Bli kunde',
					'FACEBOOK': 'Opprett konto med Facebook',
					'ERROR': {
						'DUPLICATE': 'E-postadressen er allerede registrert hos oss. Vennligst logg deg på som eksisterende kunde.',
						'SIGNUP': 'Fikk ikke til å opprette en konto.'
					},
					'BUTTON': 'Opprett konto'
				},
				'EMAIL': {
					'LABEL': 'E-postadresse',
					'INPUT': 'Oppgi e-postadressen din'
				},
				'PASSWORD': {
					'LABEL': 'Passord',
					'INPUT': 'Oppgi passordet ditt'
				}
			},
			'SSN': {
				'TITLE': 'Personnummer',
				'INFO': 'For å sikre at bare du kan bestille i ditt navn ber vi deg oppgi personnummer så henter vi din adresse fra folkeregisteret. Disse opplysningene blir behandlet strengt konfidensielt og vil aldri formidles videre.',
				'INPUT': 'Oppgi personnummer (DDMMÅÅNNNNN)',
				'CANCEL': 'Avbryt',
				'SEARCH': 'Søk etter personnummer'
			},
			'BILLING': {
				'TITLE': 'Stemmer informasjonen?',
				'NB_TITLE': 'Informasjon',
				'FIRSTNAME': 'Fornavn',
				'LASTNAME': 'Etternavn',
				'STREET': 'Gateadresse',
				'ZIPCODE': 'Postnummer',
				'CITY': 'Sted',
				'SSN': 'Personnummer',
				'SEARCH': 'Nytt søk',
				'CONFIRM': 'Informasjonen stemmer',
				'SAVE': 'Lagre informasjonen',
				'CHANGE': 'Annen leveringsadresse?'
			},
			'SHIPPING': {
				'TITLE': 'Annen leveringsadresse',
				'STREET': 'Gateadresse',
				'ZIPCODE': 'Postnummer',
				'CITY': 'Sted',
				'ERROR': {
					'FIRST': 'Vi kan dessverre ikke levere',
					'SECOND': 'til det angitte postnummeret'
				},
				'CANCEL': 'Tilbake',
				'CONFIRM': 'Bruk som leveringsadresse'
			},
			'DETAILS': {
				'TITLE': 'Detaljer',
				'PHONE': {
					'LABEL': 'Mobilnummer (obligatorisk)',
					'INPUT': 'Oppgi ditt mobilnummer, slik at sjåføren kan ringe eller tekst når leveransen er på gang'
				},
				'CODE': {
					'LABEL': 'Portkode',
					'INPUT': 'Oppgi portkode'
				},
				'FLOOR': {
					'LABEL': 'Etasje',
					'INPUT': 'Angi etasje'
				},
				'ADDITIONAL': {
					'LABEL': 'Utfyllende informasjon',
					'INPUT': 'Oppgi ev. annen leveringsinformasjon'
				},
				'CANCEL': 'Avbryt',
				'SAVE': 'Lagre detaljene'
			},
			'DELIVERY': {
				'TITLE': 'Når vil du begynne å få leveringer?',
				'INFO': 'Vi har ingen bindingstid, og du kan selv velge om du vil ha levering hver eller hver annen uke. Du kan også avbestille enkeltuker. Alle endringer gjøres på Min side.',
				'DELIVERYDAY': 'Leveringsdag',
				'CANCEL': 'Avbryt',
				'CONFIRM': 'Velg betalingsmåte'
			},
			'NO_DELIVERY': {
				'TITLE': 'Kan ikke levere til ditt postnummer',
				'INFO': 'Vi kan i øyeblikket ikke levere til ditt postnummer',
				'RETRY': 'Vil du prøve med et annet personnummer?',
				'NB_RETRY': 'Vil du prøve med et annet postnummer?'
			},
			'PAYMENT': {
				'TITLE': 'Velg betalingsmåte',
				'CARD': {
					'TITLE': 'Kortbetaling',
					'INFO': 'Du registrerer kortet ditt hos oss og mandagen før neste levering debiteres kortet for den kommende leveringsuken. Matkomfort bruker PayEx betalingssystem.',
					'BUTTON': 'Betal med kort'
				},
				'EMAIL': {
					'TITLE': 'E-postfaktura (Krever personnummer)',
					'INFO': 'Du kan betale med faktura og velge å få fakturaen sendt til deg via e-post (OBS! Dette er ikke e-faktura). Fakturaavgift: 25 kr. Fakturaer sendes annenhver mandag for bestillingene i perioden.',
					'BUTTON': 'Betal med e-postfaktura'
				},
				'INVOICE': {
					'TITLE': 'Faktura',
					'INFO': 'Du kan betale med faktura og velge å få papirfaktura sendt hjem til deg. Fakturaavgift: 25 kr. Fakturaer sendes annenhver mandag for bestillingene i perioden.',
					'BUTTON': 'Faktura'
				},
				'TERMS': {
					'FIRST': 'Jeg godkjenner Matkomforts',
					'SECOND': 'generelle betingelser.'
				},
				'FINISH': 'Fullfør bestillingen'
			},
			'PAYMENT_FAILED': {
				'TITLE': 'Betaling mislyktes',
				'INFO': 'Betalingen din gikk ikke gjennom. Prøv på nytt.',
				'RETRY': 'Vil du prøve på nytt?'
			},
			'PAYMENT_NOT_AVAILABLE': {
				'TITLE': 'Betaling mislyktes',
				'INFO': 'Du kan ej betala med faktura, men du har fortfarande alternativet att betala med kort',
				'CONFIRM': 'Betala med kort'
			},
			'RECEIPT': {
				'TITLE': 'Takk for bestillingen {{firstName}}!',
				'INFO': 'Du får straks en ordrebekreftelse sendt til {{email}}. Allerede nå kan du gå til Min side for mer informasjon og for å håndtere abonnementet.',
				'BUTTON': 'Gå til Min side'
			},
			'NB_ZIPCODE': {
				'TITLE': 'Postnummer',
				'INFO': 'Skriv inn ditt postnummer for å se om vi kan levere til deg.',
				'INPUT': 'Oppgi postnummer',
				'CANCEL': 'Avbryt',
				'SEARCH': 'Test postnummer'
			}
		},
		'MYPAGE': {
			'TERMS': {
				'ACCEPT': 'Jeg godkjenner Matkomforts generelle betingelser.',
				'SAVE': 'Godkjenn'
			},
			'GIFTCARD': {
				'INFO': 'Når du klikker på Gjennomfør bekrefter du kjøpet og du debiteres {{amount | kr}} på neste ordinære faktura/kortbelastning',
				'AMOUNT': 'Beløp',
				'MESSAGE': {
					'LABEL': 'Melding',
					'INPUT': 'Skriv gjerne inn en hilsen til den som skal få gavekortet'
				},
				'ORDER': 'Bestill',
				'CONFIRM': 'Gjennomfør',
				'CANCEL': 'Tilbake',
				'SENT': 'Takk for bestillingen av gavekort!'
			},
			'INVITE': {
				'FIRSTNAME': 'Venns fornavn',
				'LASTNAME': 'Venns etternavn',
				'EMAIL': 'Venns e-postadresse',
				'SEND': 'Send',
				'SENT': 'Du har nå invitert vennen din!'
			},
			'MENU': {
				'DELIVERY': 'Levering',
				'MONDAY': 'Mandag',
				'TUESDAY': 'Tirsdag',
				'WEDNESDAY': 'Onsdag',
				'THURSDAY': 'Torsdag',
				'FISH': 'Ukens fisk',
				'BIRD': 'Ukens fugl',
				'FANTASY': 'Ukens fantasi',
				'PDF': 'Last ned menyen som pdf.',
				'COMMENT': 'Skriv en kommentar',
				'SAVE': 'Lagre karakter',
				'COMPLETED': 'Du har allerede gitt denne menyen karakter',
				'RATING': 'Min karakter, 1-5',
				'RATING_INFO': 'Klikk på stjernene for å gi menyen karakter.',
				'RATING_SUCCESS': 'Takk for din karakter!',
				'NOT_EDITABLE': 'Du kan ikke gi denne menyen karakter',
				'NO_DELIVERY': 'Ingen levering uke {{week}}',
				'RATE': 'Gi meny karakter',
				'RATE_SAVED': 'Karakter er dermed sperret',
				'NEXT_DELIVERY': {
					'INFO': 'Neste levering publiseres torsdag ettermiddag.',
					'DELIVERY': 'Neste levering'
				},
				'CHANGE': 'Bytt meny',
				'ORDER': 'Bestill menyen',
				'NOT_CHANGEABLE': 'Du kan ikke endre denne menyen',
			},
			'OVERVIEW': {
				'PLAN': {
					'TITLE': 'Endring av leveringsplan',
					'INFO': {
						'FIRST': 'Er du sikker på at du vil gjennomføre endringene?',
						'SECOND': 'Alle manuelle endringer som er gjort på leveringsplanen vil forsvinne.'
					},
					'MENU': 'Velg meny',
					'WEEK': '{{odd ? \"Ulike\" : \"Like\"}} uker',
					'NO_DELIVERY': 'Ingen levering',
					'CHOOSE': 'Velg meny',
					'EDIT': 'Endre',
					'CHANGE': 'Bytt meny',
					'REMOVE': 'Ta bort {{odd ? \"Ulike\" : \"Like\"}} uker',
					'SAVE': 'Lagre',
					'CANCEL': 'Avbryt',
					'CONFIRM': 'Gjennomfør',
					'SUPPLEMENTS': 'ekstra hovedråvarer',
					'SERVINGS_SAVED': 'Porsjoner er nå lagret',
					'SUPPLEMENTS_SAVED': 'Ekstra hovedråvarer er nå lagret',
					'PRODUCT_SAVED': 'Produktet er nå lagret'
				},
				'ORDER': {
					'NO_DELIVERY': 'Ingen levering',
					'CHANGED': 'Manuelt endret. Avvik fra ordinært abonnement.',
					'RESUME': 'Bestill',
					'ORDER': 'Bestill',
					'REMOVE': 'Avbestill',
					'EDIT': 'Endre',
					'CHANGE': 'Bytt meny',
					'PLAN': 'Gå tilbake til ordinært abonnement',
					'SUPPLEMENTS': 'ekstra hovedråvarer',
					'DELIVERY_DAY': 'levering',
					'SAVED': 'Ordre lagret'
				},
				'ORDER_LAST_ITEM_MODAL': {
					'INFO': 'Du kan ikke bestille hele listen leveringer. Ønsker du å gjøre en lengre pause så du må stanse din abbonemang.',
					'PAUSE': 'Gå till pause abonnement',
					'CANCEL': 'Avbryt'
				},
				'MENU': {
					'CHANGE_MODAL_TITLE': 'Abonnementsendring',
					'CHOOSE': 'Velg meny',
					'CHANGE': 'Bytt meny',
					'CHANGE_TO': 'Bytt til',
					'KEEP': 'Fortsett med'
				},
				'DELIVERY_DAY': {
					'TITLE': 'leveringsdag',
					'INFO': 'Her kan du velge ønsket leveringsdato.',
					'SAVED': 'leveringsdag lagret',
					'METHOD': {
						'0': 'Søndag',
						'1': 'Mandag',
						'10': 'Last ned i ICA Stop Täby',
						'11': 'Nedlasting av Matkomfort'
					},
					'LABEL': 'Leveringsdag/-sted'
				},
				'CHOOSE_MENU_BUTTON': {
					'LABEL': 'Meny',
					'CHANGE': 'Byt Meny'
				},
				'DELIVERY_DAY_BUTTON': {
					'LABEL': ''
				}
			},
			'BONUS': {
				'POINTS': 'poeng',
				'ORDER': 'Velg',
				'MODAL': {
					'TITLE': 'Premievalg bekreftes',
					'MESSAGE': 'Jeg bestiller {{bonus}} for {{points}} poeng.',
					'CONFIRM': 'Godkjenn',
					'CANCEL': 'Avbryt'
				},
				'ORDERED': 'Premien er nå bestilt'
			},
			'ACCOUNT': {
				'DETAILS': 'Informasjon',
				'BILLING': 'Betalingsmåte',
				'PAUSE': 'Pause',
				'QUIT': 'Avslutt'
			},

			'DETAILS': {
				'ACCOUNT': {
					'TITLE': 'Informasjon',
					'EMAIL': {
						'LABEL': 'E-post',
						'INPUT': 'E-post som du bruker til å logge på med'
					},
					'EMAIL_NEWSLETTER': {
						'LABEL': 'E-post for nyhetsbrev utsendelser',
						'INPUT': 'Lyst til partnere også motta nyhetsbrev?'
					},
					'EMAIL_BILLING': {
						'LABEL': 'Alternativer e-post faktura',
						'INPUT': 'Vil du få fakturaen til en annen e-postadresse?'
					},
					'SSN': 'Personnummer',
					'CUSTOMER_NUMBER': 'Kundenummer',
					'SAVE': 'Lagre informasjonen',
					'SAVE_SUCCESS': 'Informasjonen lagret'
				},
				'PASSWORD': {
					'TITLE': 'Endre passordet ditt',
					'OLD_PASSWORD': {
						'LABEL': 'Nåværende passord',
						'INPUT': 'Oppgi din nåværende passord'
					},
					'NEW_PASSWORD': {
						'LABEL': 'Nytt passord',
						'INPUT': 'Oppgi ditt nye passord'
					},
					'SAVE': 'Lagre nytt passord',
					'SAVE_SUCCESS': 'Nytt passord lagret'
				},
				'ADDRESSES': {
					'TITLE': 'Adresser',
					'HAS_SAME_ADDRESS': 'Fakturaadresse er samme som leveringsadresse',
					'BILLING': 'Fakturaadress',
					'SHIPPING': 'Leveringsadresse',
					'SHIPPING_ALERT': {
						'TITLE': 'Husk på!',
						'INFO': 'Hvis du vil ha levering til din nye adresse allerede på søndag må du informere <a href="/kundeservice/">kundeservice</a> slik at sjåføren kjører riktig.'
					},
					'STREET': {
						'LABEL': 'Gateadresse',
						'INPUT': 'Oppgi gateadresse'
					},
					'ZIPCODE': {
						'LABEL': 'Postnummer',
						'INPUT': 'Oppgi postnummer'
					},
					'CITY': {
						'LABEL': 'Sted',
						'INPUT': 'Oppgi sted'
					},
					'SAVE': 'Lagre adresser',
					'SAVE_SUCCESS': 'Adresser er nå lagret',
					'ERROR': {
						'FIRST': 'Vi kan dessverre ikke levere',
						'SECOND': 'til det angitte postnummeret'
					}
				},
				'DETAILS': {
					'TITLE': 'Informasjon',
					'MOBILE': {
						'LABEL': 'Mobilnummer',
						'INPUT': 'Oppgi Mobilnummer',
						'INFO': 'Oppgi ditt mobilnummer, slik at sjåføren kan ringe eller tekst når leveransen er på gang'
					},
					'PHONE': {
						'LABEL': 'Hjem telefonnummer',
						'INPUT': 'Oppgi ditt hjem telefonnummer',
						'INFO': 'Oppgi et telefonnummer der vi kan nå deg.'
					},
					'CODE': {
						'LABEL': 'Portkode',
						'INPUT': 'Oppgi portkode',
						'INFO': 'For at vi skal kunne komme inn og sette igjen maten så trenger vi en ev. portkode.'
					},
					'FLOOR': {
						'LABEL': 'Etasje',
						'INPUT': 'Oppgi etasje'
					},
					'ADDITIONAL': {
						'LABEL': 'Leveringsinformasjon',
						'INPUT': 'Oppgi ev. annen leveringsinformasjon',
						'INFO': 'Informasjon som skal hjelpe føreren f.eks. hvis han/hun skal plassere maten ved garasjen.'
					},
					'TERMS_AND_CONDITIONS': 'Vilkår og betingelser',
					'SAVE': 'Lagre informasjonen',
					'SAVE_SUCCESS': 'Informasjonen lagret'
				}
			},
			'BILLING': {
				'CURRENT': {
					'TITLE': 'Nåværende betalingsmåte',
					'CARD': 'Kortbetaling',
					'VALID': 'Kort gyldig til',
					'EMAIL_INVOICE': 'E-postfaktura',
					'EMAIL': 'E-post',
					'INVOICE': 'Faktura',
					'STREET': 'Gateadresse',
					'ZIPCODE': 'Postnummer',
					'CITY': 'Sted'
				},
				'EMAIL_BILLING': {
					'TITLE': 'E-post faktura',
					'INFO': 'Ved å skrive inn en e-postadresse her slik at du kan få bill / fakturadata som sendes til denne adressen i stedet for din vanlige e-postadresse.',
					'LABEL': 'E-post',
					'INPUT': 'Hvis du ønsker å få fakturaen til en annen e-postadresse, fyll inn adressen her.',
					'INPUT_CARD': 'Hvis du ønsker å få fakturadetaljene til en annen e-postadresse, skriv adressen her.',
					'SAVE': 'Lagre',
					'SAVE_SUCCESS': 'E-post fakturaadresse lagret'
				},
				'CHANGE': {
					'TITLE': 'Bytt betalingsmåte',
					'CARD': {
						'TITLE': 'Kortbetaling',
						'INFO': 'Du registrerer kortet ditt hos oss og mandagen før neste levering debiteres kortet for den kommende leveringsuken. Matkomfort bruker PayEx betalingssystem.',
						'BUTTON': 'Betal med kort'
					},
					'EMAIL': {
						'TITLE': 'E-postfaktura',
						'INFO': 'Du kan betale med faktura og velge å få fakturaen sendt til deg via e-post (OBS! Dette er ikke e-faktura). Fakturaavgift: 25 kr. Fakturaer sendes annenhver mandag for bestillingene i perioden.',
						'BUTTON': 'Betal med e-postfaktura'
					},
					'INVOICE': {
						'TITLE': 'Faktura',
						'INFO': 'Du kan betale med faktura og velge å få papirfaktura sendt hjem til deg. Fakturaavgift: 25 kr. Fakturaer sendes annenhver mandag for bestillingene i perioden.',
						'BUTTON': 'Faktura'
					},
					'PAYMETHOD': 'Endre betalingsmåte',
					'INFO': 'Er du sikker på at du vil endre betalingsmåten?',
					'CANCEL': 'Avbryt',
					'CONFIRM': 'Endre'
				}
			},
			'PAUSE': {
				'TITLE': 'Pause abonnement',
				'INFO': 'Du kan pause abonnementet ved å trykke på knappen under',
				'PAUSED': 'Ditt abonnement er satt på pause til {{startDate}}.',
				'PAUSED_NO_START': 'Ditt abonnement er satt på pause.',
				'CANCELED': 'Abonnementet ditt er avsluttet',
				'PAUSE': 'Pause',
				'RESUME': 'Fortsett',
				'RESUME_SUCCESS': 'Abonnementet er nå gjenopptatt',
				'CANCEL': 'Avbryt',
				'CONFIRM': 'Gjennomfør',
				'CONFIRM_SUCCESS': 'Abonnementet er nå gjenopptatt',
				'STOP_DATE': 'Når ønsker du å ha din siste levering?',
				'START_DATE': 'Når ønsker du å gjenoppta abonnementet ditt?',
				'NO_DATES': 'Det er dessverre ingen tilgjengelige sluttdatoer for din valgte startdato',
				'CONFIRM_INFO': 'Hvis du ønsker å stoppe abonnementet på ubestemt tid?',
				'CONFIRM_INFO_STOP_START': 'Hvis du ønsker å stoppe abonnementet med siste levering {{stopDate}} {{stopWeek}} og {{startDate}} {{startWeek}} oppstart?',
				'CONFIRM_INFO_NO_STOP': 'Hvis du ønsker å stoppe abonnementet, og gjenoppta {{startDate}} {{startWeek}}?',
				'CONFIRM_INFO_NO_START': 'Hvis du ønsker å stoppe abonnementet med siste levering {{stopDate}} {{stopWeek}}?',
				'SAVE_SUCCESS': 'Pause lagret'
			},
			'QUIT': {
				'TITLE': 'Avslutt abonnement',
				'INFO': 'Du kan avslutte abonnementet ved å trykke på knappen under',
				'CANCELED': 'Abonnementet ditt er avsluttet',
				'BUTTON': 'Avslutt',
				'RESUME': 'Fortsett',
				'RESUME_SUCCESS': 'Abonnementet er nå gjenopptatt',
				'DATE': 'Når ønsker du å ha din siste levering?',
				'CANCEL': 'Avbryt',
				'CONFIRM': 'Gjennomfør',
				'CONFIRM_INFO': 'Er du sikker på at du vil avslutte abonnementet hos Matkomfort med siste levering {{quitDate}} {{quitWeek}}?',
				'CONFIRM_INFO_NO_STOP': 'Er du sikker på at du vil avslutte abonnementet hos Matkomfort?',
				'CONFIRM_SUCCESS': 'Abonnement ditt er nå avsluttet',
				'FORM': {
					'TITLE': 'Spørreskjema for oppsigelse',
					'INFO': 'Vi har mottatt oppsigelsen av Matkomfort og vil først takke for tilliten den tiden du var kunde hos oss. Vi setter pris på om du tar deg tid til å fylle ut spørreskjemaet under. For oss er alle kunders synspunkter viktige og det hjelper oss til å bli enda bedre.',
					'SENT': 'Takk for svaret!',
					'SEND': 'Send',
					'OTHER_ANSWER': 'annen årsak, vennligst spesifiser',
					'FIRST_QUESTION': {
						'TITLE': '1. Hvor lenge har du vært kunde hos Matkomfort?',
						'ANSWER': {
							'FIRST': 'Testkunde',
							'SECOND': 'kunde 4 - 12 uker',
							'THIRD': 'kunde 3 måneder eller lengre'
						}
					},
					'SECOND_QUESTION': {
						'TITLE': '2. Hva er den viktigste årsaken til at du har valgt å si opp abonnementet?',
						'ANSWER': {
							'FIRST': 'Barna spiser ikke nok av maten',
							'SECOND': 'For dyrt i forhold til hva min husholdning vil bruke på hverdagsmat',
							'THIRD': 'Jeg vil selv bestemme hva jeg skal spise i hverdagen',
							'FOURTH': 'Har en type allergi som gjør at jeg ikke kan spise alle retter',
							'FIFTH': 'Har problemer med å være hjemme og ta imot leveringen på søndager'
						}
					},
					'THIRD_QUESTION': {
						'TITLE': '3. Hva har vært best med konseptet?',
						'ANSWER': {
							'FIRST': 'Tidsbesparende og tid til annet',
							'SECOND': 'Trygg og sikker levering',
							'THIRD': 'Enkelt å tilberede, variert og bra mat med bra råvarer',
							'FOURTH': 'Barnevennlige menyer og både de voksne og barna i husholdningen liker maten'
						}
					},
					'FOURTH_QUESTION': {
						'TITLE': '4. Kommer du til å teste Matkomfort igjen?',
						'ANSWER': {
							'FIRST': 'Ja, absolutt, men det passer oss ikke akkurat nå',
							'SECOND': 'Ja, kanskje',
							'THIRD': 'Ikke trolig',
							'FOURTH': 'Nei'
						}
					},
					'FIFTH_QUESTION': {
						'TITLE': '5. Hvordan kommer du til å løse hverdagsmaten etter avsluttet abonnement?',
						'ANSWER': {
							'FIRST': 'Velge en annen leverandør',
							'SECOND': 'Begynne å planlegge og handle og tilberede selv igjen',
							'THIRD': 'Ikke bestemt meg'
						}
					},
					'SIXTH_QUESTION': {
						'TITLE': '6. Andre kommentarer du ønsker å gi oss som står bak Matkomfort'
					}
				}
			},
			'SPECIAL_ORDER': {
				'MODAL': {
					'TITLE': 'Beställning',
					'INFO': 'Genomför beställning',
					'CONFIRM': 'Genomför beställning',
					'CANCEL': 'Avbryt'
				},
				'SUCCESS': 'Beställning lagd'
			},
			'SUPPLEMENT_ORDER': {
				'MODAL': {
					'TITLE': 'Tillägg av {{supplement.title}} vecka {{order.week}}',
					'INFO': 'Du har valt att göra ett engångstillägg av {{supplement.title}}. Tillägget levereras vecka {{order.week}} med ordinarie leverans. Debitering kommer att ske enligt ordinarie betalsätt med {{price}} kr. Du kan fram till kl. 10 måndagen innan leverans justera eller ta bort tillägg via din abonnemangsöversikt.',
					'CONFIRM': 'Bekräfta tillägget',
					'CANCEL': 'Avbryt tillägget'
				},
				'SUCCESS': 'Vi har lagt till {{supplement.title}} till din ordinarie leverans vecka {{order.week}}. Tack för din beställning!'
			}
		},
		'THEME': {
			'COOKIES': {
				'TITLE': 'Matkomfort bruker cookies for å forbedre opplevelsen av nettsiden for deg som besøkende. Ved å fortsette på siden godkjenner du bruk av cookies.',
				'INFO': 'Hva er cookies?',
				'CLOSE': 'Lukk'
			},
			'CAMPAIGN': {
				'LINK': 'Les mer'
			},
			'FOODCOURT_MODAL': {
				'TITLE': 'DU BEVEGER DEG NÅ INN PÅ EN MATBLOGG SKREVET DELVIS PÅ NORSK OG OG DELVIS PÅ SVENSK...',
				'MESSAGE': 'Selvsagt bør du ta innholdet med en klype salt (tilsvarer omtrent ett kryddermål). Men siden kan kanskje være verdt et besøk allikevel? I så fall er du hjertelig velkommen!',
				'CLOSE': 'Ok'
			},
			'PAUSED_ACCOUNT': {
				'TITLE_DELIVERIES_LEFT': 'Abonnementet din er hvilende, siste levering {{stopDate}}, tas opp igjen {{startDate}}.',
				'TITLE_DELIVERIES_LEFT_NO_START': 'Abonnementet din er hvilende, siste levering {{stopDate}}.',
				'TITLE_RESUME': 'Abonnementet din er hvilende og tas opp igjen {{startDate}}.',
				'TITLE_RESUME_NO_START': 'abonnementet din er hvilende.',
				'RESUME': 'Gjenoppta'
			},
			'QUIT_ACCOUNT': {
				'TITLE_DELIVERIES_LEFT': 'Abonnementet din er avsluttet og siste leveringsdag er {{stopDate}}.',
				'TITLE_RESUME': 'Abonnementet ditt er avsluttet. Du kan starte opp abonnementet igjen, basert på din tidligere leveringsplan, ved å klikke',
				'RESUME': 'Gjenoppta'
			},
			'PRODUCT': {
				'ORDER': 'Bestill',
				'PORTIONS': 'porsjoner',
				'TITLE': 'Porsjoner',
				'PRICE': 'Pris'
			},
			'PORTION_BUTTON': {
				'LABEL': 'Antal porsjoner',
				'PORTIONS': 'porsjoner',
				'TITLE': 'Porsjoner',
				'PRICE': 'Pris'
			},
			'SUPPLEMENTS_BUTTON': {
				'LABEL': 'Ekstra hovedråvare',
				'TITLE': 'Ekstra hovedråvare',
				'AMOUNT': 'Antall',
				'PRICE': 'Pris'
			},
			'TEST_WEEK_BUTTON': {
				'TEST': 'Test',
				'SUBSCRIPTION': 'Abonnement'
			},
			'STICKER': {
				'ORDER': 'Bestill klistremerker',
				'ORDERED': 'Klistremerker er nå bestilt'
			},
			'RESET_PASSWORD': {
				'TITLE': 'Tilbakestill passord',
				'ERROR': 'Noe gikk galt. Prøv igjen.',
				'EMAIL_ERROR': 'Oppgi en gyldig e-postadresse',
				'SENT': 'Det nye passordet er sendt til {{email}}'
			},
			'ZIPCODE_CHECK': {
				'TITLE': 'Test postnummeret',
				'INVALID': 'Ugyldig postnummer',
				'CONFIRMED': 'Gratulerer, du kan få Matkomfort hjem på døren!',
				'UNCERTAIN': 'Vi kan kanskje levere til deg. Kontakt kundeservice for mer informasjon.',
				'NO_DELIVERY': 'Dessverre kan vi per i dag ikke levere til deg.',
				'ORDER': 'Bestill',
				'TEST': 'Test'
			},
			'GIFTCARD_CHECK': {
				'TITLE': 'Testa mottagarens postnummer',
				'INVALID': 'Ogiltigt postnummer',
				'CONFIRMED': 'Grattis, mottagaren kan få Matkomfort hem till dörren!',
				'UNCERTAIN': 'Vi kanske kan leverera till det angivna postnummret, kontakta kundtjänst för mera information.',
				'NO_DELIVERY': 'Tyvärr, vi kan i dagsläget ej leverera till det angivna postnummret.',
				'ORDER': 'Beställ',
				'TEST': 'Testa'
			}
		}
	});
});
